import React from "react"
import { UnauthorizedNav } from "./Nav"
import clsx from "clsx"
import { Crumbs } from "./BreadCrumbs"

export const UnauthorizedPageContainer: React.FC<{
  children: React.ReactNode
  breadCrumbs?: Crumbs
  className?: string
  navClassName?: string
}> = ({ children, breadCrumbs, className = "", navClassName = "" }) => {
  return (
    <div className="relative mx-auto flex min-h-screen w-full max-w-xl">
      <div className={clsx("flex min-h-full w-full flex-1 flex-col", className)}>
        <UnauthorizedNav breadCrumbs={breadCrumbs} className={navClassName} />
        <div className={className}>{children}</div>
      </div>
    </div>
  )
}
